function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* eslint-disable max-statements */
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTypedDispatch, useTypedSelector } from 'src/redux/utils';
import styles from './styles.module.scss';
import thetanLogo from 'assets/img/thetan_logo_V2.png';
import dotBackground from 'assets/img/dot_background_V2.png';
import icThree from 'assets/svg/ic_three.svg';
import icArrowRight from 'assets/svg/ic_arrow_right_V2.svg';
import imgGift from 'assets/img/img_gift.png';
import Button from 'src/Components/Button_V2';
import classNames from 'classnames';
import { cryptoBuy } from '../../config';
import { RouteName } from 'src/routes/config';
import ImageWithPlaceholder from 'src/Components/ImageWithPlaceholder';
import Spinner from 'src/Components/Spinner';
import { webImageUri } from 'src/utils/uri';
import { MKPTab } from 'src/models';
import { navigateToConnectWallet, navigateToHome, navigateToMarketplace, navigateToStaking, navigateToVestingSafe } from 'src/utils/navigate';
import CalloutContent from 'src/Components/CalloutProvider/CalloutContent';
import { CalloutPosition } from 'src/Components/CalloutProvider/types';
import { useCallout } from 'src/Components/CalloutProvider';
import { ALCHEMYPAY_CONFIG } from 'src/constants';
import noop from 'lodash/noop';
import { getSession } from 'src/utils/session';
import PageContent from 'src/Components/PageContent';
import Skeleton from 'src/Components/Skeleton';
import { AppError } from 'src/redux/types';
import { logout } from '@profile/src/redux/remoteActions';
import { useTestId } from '@wolffun/testable-id';
import { signAlchemyPaySignature } from '@main/src/utils/crypto';
import PopupModal_V2 from '@main/src/Components/PopupModal_V2';
import { currencyIconMap, currencyName } from '@wolffun/shared/src/types';

const HeaderMobile = ({
  menuList,
  avatar,
  avatarFrame
}) => {
  var _getSession;

  const {
    generateTestIdProps
  } = useTestId();
  const dispatch = useTypedDispatch();
  const signedIn = useTypedSelector(state => !!state.userProfile.user) || ((_getSession = getSession()) === null || _getSession === void 0 ? void 0 : _getSession.accessToken);
  const {
    user: profile,
    loading,
    error,
    invalidated
  } = useTypedSelector(state => state.userProfile);
  const connectWalletCampaign = useTypedSelector(state => {
    var _state$thetanWorldCon;

    return (_state$thetanWorldCon = state.thetanWorldConfig.data) === null || _state$thetanWorldCon === void 0 ? void 0 : _state$thetanWorldCon.connectWallet;
  });
  const {
    pathname,
    search
  } = useLocation();
  const {
    resetCallout
  } = useCallout();
  const [isShowNavMobile, setShowNavMobile] = React.useState(false);
  const [isShowProfileMenu, setShowProfileMenu] = React.useState(false);
  const [isShowBuyCrypto, setShowBuyCrypto] = React.useState(false);
  const refGetTHC = React.useRef(null);
  const refMenu = React.useRef(null);

  const toggleNavMobile = () => {
    resetCallout(undefined, true);
    setShowNavMobile(prev => !prev);
  };

  const renderUserProfile = () => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("label", {
      htmlFor: "navProfile",
      className: classNames(styles.navItem, styles.profile)
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.cosmetic
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.profileImage
    }, avatar && /*#__PURE__*/React.createElement(ImageWithPlaceholder, {
      className: styles.avatar,
      src: webImageUri(avatar.imageAvatar),
      renderPlaceholder: () => /*#__PURE__*/React.createElement(Spinner, {
        secondary: true,
        size: 30,
        className: styles.avatar
      })
    }), avatarFrame && /*#__PURE__*/React.createElement(ImageWithPlaceholder, {
      className: styles.avatarFrame,
      src: webImageUri(avatarFrame),
      renderPlaceholder: () => /*#__PURE__*/React.createElement(Spinner, {
        secondary: true,
        size: 30,
        className: styles.avatar
      })
    })), "My Profile"), /*#__PURE__*/React.createElement("img", {
      src: icArrowRight
    })));
  };

  const renderLoading = () => /*#__PURE__*/React.createElement(Skeleton, {
    className: styles.getBNBSkeleton
  });

  const renderContentWalletBtn = () => {
    return /*#__PURE__*/React.createElement(Button, {
      onClick: () => navigateToConnectWallet({}),
      className: classNames(styles.connectButton, styles.mobile),
      title: "Connect Wallet",
      uppercase: false,
      renderRightIcon: () => connectWalletCampaign ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: styles.fakeGift
      }), /*#__PURE__*/React.createElement("img", {
        src: imgGift,
        className: styles.imgGift
      })) : null
    });
  };

  const renderGetTHC = () => {
    if (!(profile !== null && profile !== void 0 && profile.address)) {
      return null;
    }

    return /*#__PURE__*/React.createElement("div", {
      ref: refGetTHC,
      className: styles.getThcBtn,
      onClick: () => setShowBuyCrypto(true)
    }, /*#__PURE__*/React.createElement("div", {
      className: classNames(styles.getThcBtnContent)
    }, /*#__PURE__*/React.createElement("span", {
      className: styles.textGetThc
    }, "Buy Crypto")));
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, signedIn && isShowBuyCrypto && /*#__PURE__*/React.createElement(PopupModal_V2, {
    onClose: () => setShowBuyCrypto(false),
    header: "Choose Crypto",
    className: styles.modal
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.buyCryptoDesc
  }, "Please choose the cryptocurrency for purchase"), /*#__PURE__*/React.createElement("div", {
    className: styles.buyCryptoGroupBtn
  }, cryptoBuy.map(item => /*#__PURE__*/React.createElement(Button, {
    title: `Buy ${currencyName[item]}`,
    icon: currencyIconMap[item],
    className: styles.buyCryptoBtn,
    key: item,
    onClick: () => {
      if (!(profile !== null && profile !== void 0 && profile.address)) return;
      const signature = signAlchemyPaySignature(ALCHEMYPAY_CONFIG.appId, ALCHEMYPAY_CONFIG.secret, profile === null || profile === void 0 ? void 0 : profile.address);
      setShowBuyCrypto(false);
      const url = `${ALCHEMYPAY_CONFIG.endpoint}/?appId=${ALCHEMYPAY_CONFIG.appId}&address=${profile === null || profile === void 0 ? void 0 : profile.address}&sign=${signature}&crypto=${currencyName[item]}&network=BSC`;
      window.open(url, '_blank');
    }
  })))), /*#__PURE__*/React.createElement("div", {
    className: styles.fakeHeader
  }), /*#__PURE__*/React.createElement("div", _extends({
    className: styles.rootMobile
  }, generateTestIdProps('container')), /*#__PURE__*/React.createElement(Link, {
    className: styles.marketplace,
    to: RouteName.HomeDashboard
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.label, styles.home)
  }, /*#__PURE__*/React.createElement("img", {
    src: thetanLogo,
    className: styles.logo
  }), /*#__PURE__*/React.createElement("img", {
    src: dotBackground,
    className: styles.dotBackground
  }))), signedIn ? /*#__PURE__*/React.createElement(PageContent, {
    error: error !== AppError.NO_ERROR,
    loading: loading,
    invalidated: invalidated,
    renderContent: renderGetTHC,
    renderError: renderLoading,
    renderLoading: renderLoading
  }) : renderContentWalletBtn(), /*#__PURE__*/React.createElement(CalloutContent, {
    className: styles.menu,
    isHamburger: true,
    position: CalloutPosition.BOTTOM_LEFT
  }, /*#__PURE__*/React.createElement("div", {
    ref: refMenu,
    onClick: toggleNavMobile
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "navMobile"
  }, /*#__PURE__*/React.createElement("img", {
    src: icThree
  }))))), /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    checked: isShowNavMobile,
    className: styles.inputCheck,
    onChange: noop,
    id: "navMobile"
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: "navMobile",
    className: styles.overlay,
    onClick: toggleNavMobile
  }), /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.nav, !isShowProfileMenu && styles.overflow)
  }, signedIn && renderUserProfile(), /*#__PURE__*/React.createElement("label", {
    htmlFor: "navMobile",
    onClick: () => {
      toggleNavMobile();
      navigateToHome();
    },
    className: classNames(styles.navItem, [RouteName.HomeDashboard.toString(), RouteName.Dashboard.toString()].includes(pathname) && styles.active)
  }, /*#__PURE__*/React.createElement(CalloutContent, {
    calloutDisabled: true,
    calloutTab: MKPTab.Dashboard
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.liveDot
  })), /*#__PURE__*/React.createElement("span", null, "Dashboard")), /*#__PURE__*/React.createElement("label", {
    onClick: () => {
      toggleNavMobile();
      navigateToMarketplace();
    },
    className: classNames(styles.navItem, pathname === RouteName.MarketPlace && styles.active)
  }, /*#__PURE__*/React.createElement(CalloutContent, {
    calloutDisabled: true,
    calloutTab: MKPTab.Buy
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.liveDot
  })), /*#__PURE__*/React.createElement("span", null, "Buy")), /*#__PURE__*/React.createElement("label", {
    onClick: () => {
      toggleNavMobile();
      navigateToStaking();
    },
    className: classNames(styles.navItem, [RouteName.Staking.toString(), RouteName.YourStaking.toString()].includes(pathname) && styles.active)
  }, /*#__PURE__*/React.createElement(CalloutContent, {
    calloutDisabled: true,
    calloutTab: MKPTab.Staking
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.liveDot
  })), /*#__PURE__*/React.createElement("span", null, "Staking")), /*#__PURE__*/React.createElement("label", {
    onClick: () => {
      toggleNavMobile();
      navigateToVestingSafe();
    },
    className: classNames(styles.navItem, pathname === RouteName.VestingSafe && styles.active)
  }, /*#__PURE__*/React.createElement(CalloutContent, {
    calloutDisabled: true,
    calloutTab: MKPTab.VestingSafe
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.liveDot
  })), /*#__PURE__*/React.createElement("span", null, "Vesting Safe")), signedIn && /*#__PURE__*/React.createElement("label", {
    onClick: () => {
      dispatch(logout());
      navigateToHome();
    },
    className: classNames(styles.navItem, styles.logout)
  }, /*#__PURE__*/React.createElement("span", null, "Log Out")), /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    className: styles.ipCkProfile,
    id: "navProfile",
    checked: isShowProfileMenu,
    onChange: () => {
      setShowProfileMenu(prev => !prev);
    }
  }), isShowProfileMenu && /*#__PURE__*/React.createElement("div", {
    className: styles.navChild
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "navProfile",
    className: classNames(styles.navItem, styles.profile)
  }, /*#__PURE__*/React.createElement("img", {
    className: styles.arrowIcon,
    src: icArrowRight
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.lbl
  }, "My Profile")), menuList.map(e => /*#__PURE__*/React.createElement("label", {
    key: e.key,
    onClick: () => {
      var _e$handlePress;

      (_e$handlePress = e.handlePress) === null || _e$handlePress === void 0 ? void 0 : _e$handlePress.call(e, {
        dispatch
      });
      toggleNavMobile();
    },
    className: classNames(styles.navItem, pathname === RouteName.Profile && search.includes(e.key) ? styles.active : null)
  }, e.name)))));
};

export default HeaderMobile;